import { render, staticRenderFns } from "./PaymentTariffRuleImportWorkListTable.vue?vue&type=template&id=21deac44&scoped=true&lang=pug"
import script from "./PaymentTariffRuleImportWorkListTable.vue?vue&type=script&lang=js"
export * from "./PaymentTariffRuleImportWorkListTable.vue?vue&type=script&lang=js"
import style0 from "./PaymentTariffRuleImportWorkListTable.vue?vue&type=style&index=0&id=21deac44&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21deac44",
  null
  
)

export default component.exports